// @ts-nocheck
import React from 'react';
import PropTypes from 'react-proptypes';
import Link from '../../shared/editor-link';
import { PrintIcon, HistoryIcon, TrashIcon } from '../../icons';

export default class EditMenu extends React.Component {
  static propTypes = {
    open: PropTypes.bool.isRequired,
    onPrintClick: PropTypes.func.isRequired,
    onHistoryClick: PropTypes.func.isRequired,
    onDeleteClick: PropTypes.func.isRequired,
    allowPrint: PropTypes.bool.isRequired,
    allowDelete: PropTypes.bool.isRequired,
  };

  render() {
    const { styles } = EditMenu;
    const style = { display: this.props.open ? 'block' : 'none' };

    return (
      <ul
        className={css(styles.container)}
        style={style}
        title=""
      >
        {this.props.allowPrint
          && (
            <li>
              <Link
                className={styles.item}
                onClick={this.props.onPrintClick}
              >
                <PrintIcon className={styles.icon} />
                <span className={styles.itemLabel}>Print</span>
              </Link>
            </li>
          )}
        <li>
          <Link
            className={styles.item}
            onClick={this.props.onHistoryClick}
          >
            <HistoryIcon className={styles.icon} />
            <span className={styles.itemLabel}>History</span>
          </Link>
        </li>
        {this.props.allowDelete
          && (
            <li>
              <Link
                className={css(styles.item, styles.delete)}
                onClick={this.props.onDeleteClick}
                dataTestID="deleteicon-button"
              >
                <TrashIcon className={styles.icon} />
                <span className={styles.itemLabel}>Delete</span>
              </Link>
            </li>
          )}
      </ul>
    );
  }
}

const styles = cssInJS({
  container: {
    position: 'relative',
    top: 0,
    margin: 0,
    padding: 0,
    listStyleType: 'none',
    marginLeft: -48,
    marginTop: 0,
    width: 96,
    backgroundColor: '#f9f9f9',
    boxShadow: '0px 8px 16px 0px rgba(0,0,0,0.2)',
    zIndex: 4000,
  },

  item: {
    textAlign: 'left',
    padding: 12,
    paddingTop: 8,
    display: 'block',
    textDecoration: 'none',
    color: '#444',
    verticalAlign: 'middle',
    fill: '#222',

    ':hover': {
      backgroundColor: '#f1f1f1',
      color: '#222',
    },
  },

  icon: {
    display: 'inline-block',
    width: 16,
    height: 16,
    marginRight: 8,
    verticalAlign: 'middle',
    textAlign: 'center',
  },

  itemLabel: {
    verticalAlign: 'middle',
    fontSize: 13,
  },
});

EditMenu.styles = styles;
